import { canGetOrganizationAssetGroupsPage } from "@/route-authorization";
export const organization = {
  routes: [
    {
      path: "/organization/asset-group/inventory",
      meta: { rules: [canGetOrganizationAssetGroupsPage] }, // TKP-150
      component: () => import("../organization-asset-group-category-asset-group-inventory-list-view"),
    },
    {
      path: "/organization/asset-group/criticality",
      meta: { rules: [canGetOrganizationAssetGroupsPage] }, // TKP-150
      component: () => import("../organization-asset-group-category-asset-group-criticality-view"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/inventory",
      component: () => import("../ddo-asset-group-category-asset-group-inventory-list-view"),
    },
    {
      path: "/ddo/asset-group/criticality",
      component: () => import("../ddo-asset-group-category-asset-group-criticality-view"),
    },
  ],
};
export const bgys = {
  routes: [
    {
      path: "/bgys/inventory",
      component: () => import("../bgys-asset-group-category-asset-group-inventory-list-view"),
    },
    {
      path: "/bgys/asset-group/criticality",
      component: () => import("../bgys-asset-group-category-asset-group-criticality-view"),
    },
  ],
};
